import { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import { RootStateDto } from "dto/redux/store-dto";
import ErrorResponseDto from "dto/services/error-response-dto";
import AppResourceInputDto from "dto/components/pages/resources/app-resource-input-dto";

import AppInput from "components/app-input";

const AppResourceInput = ({ detail }: AppResourceInputDto) => {
	const [valueBeforeUpdate, setValueBeforeUpdate] = useState(detail.value || "");
	const formatKey = detail.key.replaceAll(".", "-");
	const { customerId } = useSelector((state: RootStateDto) => state.profile);

	const formik = useFormik<Record<string, any>>({
		initialValues: {},
		onSubmit: () => {},
	});

	//prettier-ignore
	const onHandleBlur = useCallback(async (event: React.FocusEvent<HTMLInputElement>) => {
        const valueToBeUpdate = event.target.value || "";

        if (valueBeforeUpdate !== valueToBeUpdate) {
            const payload = {
                id: detail.templateId,
                customerId: customerId,
                template: detail.activeTemplate,
                page: detail.page,
                key: detail.key,
                type: detail.type,
                placeholder: detail.placeholder,
                isArray: detail.isArray,
                value: valueToBeUpdate,
            };

            setValueBeforeUpdate(valueToBeUpdate);

            try {
                await api.post.resources.update(payload);

                setValueBeforeUpdate(valueToBeUpdate);

                serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);
            } catch (error) {
                const err = error as Error | ErrorResponseDto;

                serveRequestErrors(err);
            }
        }
    }, [customerId, detail.activeTemplate, detail.isArray, detail.key, detail.page, detail.placeholder, detail.templateId, detail.type, valueBeforeUpdate]);

	useEffect(() => {
		if (formatKey) {
			formik.registerField(formatKey, {});

			formik.setFieldValue(formatKey, detail.value);
		}

		return () => {
			formik.unregisterField(formatKey);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formatKey, detail.value]);

	return <AppInput type="text" name={formatKey} label={detail?.label || detail.key} value={formik.values[formatKey] || ""} placeholder="" onChange={formik.handleChange} onBlur={onHandleBlur} />;
};

export default AppResourceInput;
